"use client";
import React, { memo, useMemo } from "react";
import { LeftArrowIcon } from "./leftArrowIcon";
import { RightArrowIcon } from "./rightArrowIcon";
import { useSearchParams, usePathname } from "next/navigation";
import { useRouter } from "next13-progressbar";

export const Pagination = ({
  totalPages,
  currentPage,
  onPageChange,
  pageSize,
  itemCount,
  totalItemCount
}: any) => {
  const searchParams = useSearchParams();
  const pathName = usePathname();
  const { push } = useRouter();
  const handlePageChange = (page: number) => {
    const params = new URLSearchParams(searchParams || "");
    params.set("page", page.toString());
    push(`${pathName}?${params.toString()}`);
    onPageChange && onPageChange(page);
  };
  const pageNumbers: any = useMemo(
    () =>
      getPageNumbers({
        totalPages,
        currentPage,
        handlePageChange,
      }),
    [totalPages, currentPage, handlePageChange]
  );

  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = startItem + itemCount - 1;

  if (!pageNumbers || pageNumbers.length === 0) {
    return <></>;
  }
  return (
    <>
      <div className="mt-6 flex flex-col items-center">
        <div className="flex justify-center mb-2">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="mx-1 px-3 py-2 disabled:opacity-20"
            aria-label="Left Arrow"
          >
            <LeftArrowIcon />
          </button>
          <div className="flex flex-row items-center">{pageNumbers}</div>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="mx-1 px-3 py-2 disabled:opacity-20"
            aria-label="Right Arrow"
          >
            <RightArrowIcon />
          </button>
        </div>
        {!Number.isNaN(startItem) &&
          startItem > 0 &&
          !Number.isNaN(endItem) &&
          endItem > 0 && (
            <div>
              <p>
                Showing item(s) {startItem}-{endItem} of {totalItemCount}
              </p>
            </div>
          )}
      </div>
    </>
  );
};

const ellipsis = <span key="ellipsis">...</span>;

const getPageNumbers = ({ totalPages, currentPage, handlePageChange }: any) => {
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      i === currentPage ||
      (i >= currentPage - 1 && i <= currentPage + 1)
    ) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`mx-4 ${currentPage === i ? "font-bold " : ""}`}
        >
          <p
            className={` ${
              currentPage === i ? "font-bold border-b-2 border-b-[#1A56DB]" : ""
            }`}
          >
            {i}
          </p>
        </button>
      );
    } else if (
      (i === currentPage - 2 && currentPage > 3) ||
      (i === currentPage + 2 && currentPage < totalPages - 2)
    ) {
      pageNumbers.push(ellipsis);
    }
  }
  return pageNumbers;
};

export default memo(Pagination);
